import axios from 'axios';

let apiToken = null;
let tokenRefreshCallback = null;

export const setApiToken = (token) => { apiToken = token; };
export const getApiToken = () => apiToken;
export const setTokenRefreshCallback = (callback) => { tokenRefreshCallback = callback; };
export const refreshApiToken = async () => {
  if (!tokenRefreshCallback) return null;
  const token = await tokenRefreshCallback();
  if (token) apiToken = token;
  return token || null;
};

export const SERVICE_URLS = {
  tenant:
    process.env.REACT_APP_ENV === 'local'
      ? 'http://localhost:3001/api'
      : process.env.REACT_APP_TENANT_API,
  company:
    process.env.REACT_APP_ENV === 'local'
      ? 'http://localhost:3002/api'
      : process.env.REACT_APP_COMPANY_API,
  underwriting:
    process.env.REACT_APP_ENV === 'local'
      ? 'http://localhost:3003/api'
      : process.env.REACT_APP_UNDERWRITING_API,
  webSocketServer:
    process.env.REACT_APP_ENV === 'local'
      ? 'ws://localhost:3003'
      : process.env.REACT_APP_UNDERWRITING_API?.replace('https://', 'wss://'),
};

export const getApiClient = (service) => {
  const baseURL = SERVICE_URLS[service];
  if (!baseURL) throw new Error(`Unknown service: ${service}`);
  const client = axios.create({
    baseURL,
    headers: { 'Content-Type': 'application/json' },
  });
  
  // Request interceptor to add auth token
  client.interceptors.request.use(
    (config) => {
      if (apiToken) config.headers.Authorization = `Bearer ${apiToken}`;
      return config;
    },
    (error) => Promise.reject(error)
  );
  
  // Response interceptor to handle 401 errors and trigger token refresh
  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      
      // If we get a 401 and haven't already tried to refresh
      if (error.response?.status === 401 && !originalRequest._retry && tokenRefreshCallback) {
        originalRequest._retry = true;
        console.log('🔄 401 detected, attempting token refresh...');
        
        try {
          // Attempt to refresh the token
          const newToken = await refreshApiToken();
          if (newToken) {
            apiToken = newToken;
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            console.log('✅ Token refreshed, retrying original request...');
            return client(originalRequest);
          }
        } catch (refreshError) {
          console.error('❌ Token refresh failed:', refreshError);
          // Let the original 401 error bubble up if refresh fails
        }
      }
      
      return Promise.reject(error);
    }
  );
  
  return client;
};
